import moment from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const MULTI_DATE_FORMATS = [
  'MM/DD/YYYY',
  'MM-DD-YYYY',
  'MMDDYYYY',
  'MM/D/YYYY',
  'MM-D-YYYY',
  'M/DD/YYYY',
  'M-DD-YYYY',
  'M/D/YYYY',
  'M-D-YYYY',
  'YYYY-MM-DD',
  'YYYY-MD-D',
  'YYYY-M-DD',
  'YYYY-M-D'
];

export const getAge = birthDate =>
  Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e10);

export const dateToString = date => (date ? date.format(DATE_FORMAT) : null);
export const stringToDate = str => moment(str, DATE_FORMAT);

export const stringToUIString = (str, fallback = '') => {
  let date = stringToDate(str);
  if (!date.isValid()) {
    return fallback;
  }
  return date.format('MM/DD/YYYY');
};

export const today = () => moment();
